import { useMemo } from 'react';

import { useTemplateDetailsStore } from '@store/templateDetailsStore';

export default function useCurrentLanguageEditorState() {
  const currentLanguage = useTemplateDetailsStore((s) => s.currentLanguage);
  const editor = useTemplateDetailsStore((s) => s.editor);
  const source = useTemplateDetailsStore((s) => s.source);

  const currentLanguageEditorState = useMemo(() => {
    return (
      source?.structure &&
      editor?.find(({ language }) => language === currentLanguage)
    );
  }, [currentLanguage, source?.structure, editor]);

  return { currentLanguageEditorState, currentLanguage, editor, source };
}
